import React,{ useEffect } from 'react';
import ReactDOM from 'react-dom';
import { 
  HashRouter as Router, 
  Route,
  Switch,
  useLocation
} from 'react-router-dom'
import './reset.css'
import Header from './components/header/header'
import Footer from './components/footer'
import Index from './view/index/index';
import Page from './view/list/page';
import Case from './view/case';
import About from './view/about';

const useScrollToTop = () =>{
  const { pathname } = useLocation(); 
  useEffect(()=>{
    window.scrollTo(0,0)
  },[pathname])
}

const Rswitch = () => {
  useScrollToTop()
  return(
    <Switch>
      <Route path="/" exact component = { Index }></Route>
      <Route path="/list/:id" exact component = { Page }></Route>
      <Route path="/case" exact component = { Case }></Route>
      <Route path="/about" exact  component = { About }></Route>
    </Switch>
  )
}
ReactDOM.render(
  <div>
    <Router>
      <Route component={ Header }></Route>
      <Rswitch />
    </Router>
    <Footer/>
  </div>,
  document.getElementById('root')
);
